// Shared upload of a generated summary PDF (fees or docs) to S3 through
// /api/send_to_S3, so the Past Transactions page can redownload it later.

const SERVER_URL = process.env.REACT_APP_API_URL;

const VIN_PATTERN = /^[A-HJ-NPR-Z0-9]{17}$/;

// The VIN the summary is filed under in S3. send_to_S3 only accepts a
// well-formed, upper-case VIN, so normalise the form's value and fall back to
// the VIN the transaction ID starts with (always the VIN the transaction ran
// under) when the form's value is missing or malformed.
export const vinForUpload = (formVin, transactionId) => {
  const fromForm = String(formVin || '').trim().toUpperCase();
  if (VIN_PATTERN.test(fromForm)) {
    return fromForm;
  }
  return String(transactionId || '').split('_')[0].toUpperCase();
};

// POST the PDF to send_to_S3. Throws if the upload is rejected, so callers can
// tell a real success from a 4xx/5xx (the old inline copies logged "S3 Upload
// Success" for any response, which hid every rejected upload).
export const uploadSummaryPdfToS3 = async ({ pdfBlob, fileName, callType, vin }) => {
  const formData = new FormData();
  formData.append('file', pdfBlob, fileName);
  formData.append('fileName', fileName);
  formData.append('call_type', callType);
  formData.append('vin', vin);

  const csrfResponse = await fetch(`${SERVER_URL}/api/get-csrf-token`, {
    method: 'GET',
    credentials: 'include',
  });
  const { csrf_token: csrfToken } = await csrfResponse.json();
  if (!csrfToken) {
    throw new Error('CSRF token not found.');
  }

  const result = await fetch(`${SERVER_URL}/api/send_to_S3`, {
    method: 'POST',
    headers: { 'X-Csrftoken': csrfToken },
    body: formData,
    credentials: 'include',
  });
  let body = null;
  try {
    body = await result.json();
  } catch {
    // Non-JSON body; the status code is what matters.
  }
  if (!result.ok) {
    throw new Error(`send_to_S3 returned ${result.status}: ${body?.error || 'unknown error'}`);
  }
  return body;
};
